module.exports = __webpack_public_path__ + "img/dark_box3_item_bg1.209537b6.png";